import { EmailDesign } from "@/stores/emailBuilderStore";

export const DefaultFailedRecurringChargeEmail = (design: EmailDesign) => {
    return {
        page: {
            body: {
                container: {
                    style: {
                        "background-color": "#FFFFFF",
                    },
                },
                content: {
                    computedStyle: {
                        align: "center",
                        linkColor: "#0015ADE8",
                        messageBackgroundColor: "transparent",
                        messageWidth: "600px",
                    },
                    style: {
                        color: "#000000",
                        "font-family":
                            "'Helvetica Neue', Helvetica, Arial, sans-serif",
                    },
                },
                webFonts: [],
            },
            description: "",
            rows: [
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnAmp: false,
                                            hideContentOnDesktop: false,
                                            hideContentOnHtml: false,
                                            hideContentOnMobile: false,
                                        },
                                        html: {
                                            html: `<img src="${design.logoUrl}" alt="Organization Logo" style="width:25%;" />`,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-html",
                                    uuid: "c44164f8-39a9-44e8-98f1-bc6fc1777e4f",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "35px",
                            },
                            uuid: "f5c765dd-e108-4635-9a1d-be8db763a5a2",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "dc2329f9-255a-40bd-8603-d0b9083e0d4c",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "25px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:&#39;Helvetica Neue&#39;, Helvetica, Arial, sans-serif;" data-mce-style="font-size:14px;line-height:16px;font-family:&#39;Helvetica Neue&#39;, Helvetica, Arial, sans-serif;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:26px;line-height:31px;" data-mce-style="font-size:26px;line-height:31px;">There was a problem with your recurring gift charge.</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "font-family":
                                                    "'Helvetica Neue', Helvetica, Arial, sans-serif",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "b2a763e4-91ca-4381-a2ae-4c37a27a488a",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "40px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "f06d8d4f-102c-49dc-8862-ab57a6acb4dc",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:21px;font-family:inherit;" data-mce-style="font-size:14px;line-height:21px;font-family:inherit;"><p style="font-size:14px;line-height:21px;word-break:break-word;text-align:left;" data-mce-style="font-size:14px;line-height:21px;word-break:break-word;text-align:left;"><span style="font-size:16px;line-height:24px;" data-mce-style="font-size:16px;line-height:24px;">When we attempted to process your recurring gift, we ran into an issue. Please contact our team or access your Donor Portal to verify your information is correct. Your gift details are shown below.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "13256183-1d97-4619-abc9-f2bff01b7fad",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "20px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "10px",
                            },
                            uuid: "78db0f17-51cc-44cf-90dd-baa176e0bfab",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "77ed9fb6-b6ee-4195-bd39-15c20fd7ff8f",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;" data-mce-style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Organization Name</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{OrganizationName}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Gift Amount</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftAmount}}</span><br/><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Payment Method</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftPaymentLast4}}</span></p><p style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;" data-mce-style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;">&nbsp;</p><p style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;" data-mce-style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Frequency</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringFrequency}}</span></p><p style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;" data-mce-style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;">&nbsp;</p><p style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;" data-mce-style="font-size:15px;line-height:18px;word-break:break-word;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong>Project Allocation(s)</strong></span><br/><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{RecurringGiftProjects}}</span></p></div>',
                                            style: {
                                                color: "#6f6f6f",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "34d41094-5b29-43e1-8438-b9e5b8dc1e3d",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "30px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "25px",
                            },
                            uuid: "11a96931-109c-4df7-a953-85db3ae186c0",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#fafafa",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "20px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "8d96674d-89e7-440b-a6bf-b8d2ba1dfec3",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "35px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "45px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "cc5fd9f2-06ce-46b3-808b-a29984a8e0f2",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "7px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:18px;line-height:21px;" data-mce-style="font-size:18px;line-height:21px;">Manage Your Donation</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "35a8e4ca-9b16-4e73-9f38-ab80d1baf047",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="line-height:14px;word-break:break-word;text-align:left;" data-renderer-start-pos="9306" data-mce-style="line-height:14px;word-break:break-word;text-align:left;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">Easily update your contact information, make changes to your recurring gift, and have receipts resent to you by email.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "ca3419a6-9ef2-4af0-96f1-cf8a6e599b3c",
                                },
                                {
                                    descriptor: {
                                        button: {
                                            href: "{{DonorPortalLogin}}",
                                            label: '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">Donor Portal Login</p></div>',
                                            style: {
                                                "background-color": "#333333",
                                                "border-bottom":
                                                    "0px solid transparent",
                                                "border-left":
                                                    "0px solid transparent",
                                                "border-radius": "30px",
                                                "border-right":
                                                    "0px solid transparent",
                                                "border-top":
                                                    "0px solid transparent",
                                                color: "#FFFFFF",
                                                direction: "ltr",
                                                "font-family": "inherit",
                                                "font-size": "15px",
                                                "font-weight": "400",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "35px",
                                                "padding-right": "35px",
                                                "padding-top": "5px",
                                                width: "auto",
                                            },
                                            target: "_blank",
                                        },
                                        computedStyle: {
                                            height: 40,
                                            hideContentOnMobile: false,
                                            width: 196,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-button",
                                    uuid: "a5c87490-0470-4aef-87bf-a47c3fe54221",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "35px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "ad4b1e57-7be5-4c15-992a-f1cc6d447b40",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0 solid transparent",
                                "border-left": "0 solid transparent",
                                "border-right": "0 solid transparent",
                                "border-top": "0 solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px",
                            },
                            uuid: "de6e5770-f804-49e1-b9ef-bea405585617",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "54f9aa03-eb33-4d79-ba9b-f0496db00350",
                },
            ],
            template: {
                version: "2.0.0",
            },
            title: "",
        },
        comments: {},
    };
};
